<template>
  <div>
    <b-modal
        v-model="modalValue"
        size="xl"
        hide-footer
        hide-header
        no-close-on-backdrop
      >
        <div class="card card-custom card-stretch">
        <!--begin::Header-->
        <div class="card-header border-0 align-items-center">
          <h3 class="card-title align-items-start flex-column">
            <span class="title font-weight-bold" v-if="selectYieldManagement === null">
              {{ i18n.workRegistration }}
            </span>
            <span class="title font-weight-bold" v-else>
              {{ i18n.yieldRegistration }}
            </span>
          </h3>
          <div class="card-toolbar toolbar-symbol">
            <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="modalValue = false">
              <i class="la la-close font-size-h5"></i>
            </b-button>
          </div>
        </div>
        <!--end::Header-->
        <!-- begin::Body -->

        <div class="card-body pt-5">

          <!-- 작업 -->
          <div v-show="performanceTap.state === 0 && selectYieldManagement === null">
            <div class="form-group row mb-4">
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.workDate}}</span>
              </label>
              <div class="col-sm-4" v-if="selectYieldManagement === null">
                <b-form-datepicker
                  v-model="workDate"
                  menu-class="w-"
                  calendar-width="100%"
                  class="mb-2 disabled-white"
                  :locale="locale"
                  :placeholder="`${i18n.yearMonthDay}`"
                ></b-form-datepicker>
              </div>
              <div class="col-sm-4" v-else>
                <b-form-datepicker
                  v-model="workDate"
                  menu-class="w-"
                  calendar-width="100%"
                  :locale="locale"
                  :placeholder="`${i18n.yearMonthDay}`"
                  class="disabled-gray"
                  :disabled="true"
                ></b-form-datepicker>
              </div>
              
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.crop}}</span>
              </label>
              <div class="col-sm-4" v-if="selectYieldManagement === null">
                <b-form-select v-model="cropNo" 
                  :options="cropList" 
                  class="disabled-white"
                  ></b-form-select>
              </div>
              <div class="col-sm-4" v-else>
                <div class="farm-form-control form-control disabled-gray">{{ cropNm }}</div>
              </div>
            </div>
          </div>

          <!-- 공정등록 -->
          <div v-show="selectYieldManagement !== null">
            <div class="form-group row mb-4">
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.workDate}}</span>
              </label>
              <div class="col-sm-4" v-if="selectYieldManagement === null">
                <b-form-datepicker
                  v-model="workDate"
                  menu-class="w-"
                  calendar-width="100%"
                  class="mb-2 disabled-white"
                  :locale="locale"
                  :placeholder="`${i18n.yearMonthDay}`"
                ></b-form-datepicker>
              </div>
              <div class="col-sm-4" v-else>
                <b-form-datepicker
                  v-model="workDate"
                  menu-class="w-"
                  calendar-width="100%"
                  :locale="locale"
                  :placeholder="`${i18n.yearMonthDay}`"
                  class="disabled-gray"
                  :disabled="true"
                ></b-form-datepicker>
              </div>
              
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.crop}}</span>
              </label>
              <div class="col-sm-4" v-if="selectYieldManagement === null">
                <b-form-select v-model="cropNo" 
                  :options="cropList" 
                  class="disabled-white"
                  ></b-form-select>
              </div>
              <div class="col-sm-4" v-else>
                <div class="farm-form-control form-control disabled-gray">{{ locale === 'ko' ? cropNm: cropNmEn }}</div>
              </div>
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <b-button v-if="workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement(0)">
                <span >{{ i18n.delete }}</span>
              </b-button>
            </div>

            <label class="col-form-label">
              <span class="h4">{{i18n.sowing}}</span>
            </label>
            <div class="form-group row mb-4">

              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.usedSowingTray}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <input
                  v-model="sowing1.usedSowingTray"
                  type="number"
                  @input="limitNumberObject('sowing1','usedSowingTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.sowingTotalCapa}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <input
                  v-model="sowing1.sowingTotalCapa"
                  type="number"
                  @input="limitNumberObject('sowing1','sowingTotalCapa', 6)"
                  class="farm-form-control form-control"
                >
              </div> -->
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.sowingRate}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <div class="farm-form-control form-control disabled-gray">{{ sowing1.sowingRate }}</div>
              </div> -->

            </div>
            
            <div style="display: flex; justify-content: flex-end;">
              <b-button variant="primary" size="lg" @click="insertYieldManagement(1)"><span >{{ i18n.register }}</span></b-button>
              <b-button v-if="sowing1.workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement(1)">
                <span >{{ i18n.delete }}</span>
              </b-button>
            </div>

            <label class="col-form-label">
              <span class="h4">{{i18n.seedling}}</span> 
            </label>
            <div
              class="form-group row mb-4"
              v-for="(seed, idx) in seedling1"
              :key="`seedling-${idx}`"
              style="padding-bottom: 15px; border-bottom: 1px solid #E4E6EF;"
            >
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.sowingDate}}</span>
              </label>
              <div class="col-sm-4">
                <b-form-select
                  v-model="seed.seedlingSowingNo"
                  :options="sowingDateList"
                  class="disabled-white"
                ></b-form-select>
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.usedSeedlingTray}}</span>
              </label>
              <div class="col-sm-4">
                <input
                  v-model="seed.seedlingUsedSeedlingTray"
                  type="number"
                  @input="limitNumberObjectArray('seedling1', idx, 'seedlingUsedSeedlingTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.seedlingTotalCapa}}</span>
              </label>
              <div class="col-sm-4">
                <input
                  v-model="seed.seedlingTotalCapa"
                  type="number"
                  @input="limitNumberObjectArray('seedling1', idx, 'seedlingTotalCapa', 6)"
                  class="farm-form-control form-control"
                >
              </div> -->
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.germinationRate}}</span>
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <input
                  v-model="seed.germinationRate"
                  type="number"
                  @input="limitNumberObjectArray('seedling1', idx, 'germinationRate', 6)"
                  class="farm-form-control form-control"
                >
              </div>
            </div>
            <div class="text-center mt-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="addRow('seedling1',selectYieldManagement.cropNo)"
                class="mx-1"
              >+</b-button>
              <b-button
                v-if="seedling1.length > 1"
                variant="outline-danger"
                size="sm"
                @click="removeRow(seedling1.length - 1, 'seedling1')"
                class="mx-1"
              >-</b-button>
            </div>

            <div style="display: flex; justify-content: flex-end;">
              <b-button variant="primary" size="lg" @click="insertYieldManagement(2)"><span >{{ i18n.register }}</span></b-button>
              <b-button v-if="seedling1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement(2)">
                <span >{{ i18n.delete }}</span>
              </b-button>
            </div>

            <label class="col-form-label">
              <span class="h4">{{i18n.transplant}}</span> 
            </label>
            <div
              class="form-group row mb-4"
              v-for="(trans, idx) in transplant1"
              :key="`transplant-${idx}`"
              style="padding-bottom: 15px; border-bottom: 1px solid #E4E6EF;"
            >
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.sowingDate}}</span> <!-- 파종일 -->
              </label>
              <div class="col-sm-4">
                <b-form-select
                  v-model="trans.transplantSowingNo"
                  :options="sowingDateList"
                  class="disabled-white"
                ></b-form-select>
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.usedSeedlingTray}}</span> <!-- 사용 모판 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="trans.transplantUsedSeedlingTray"
                  type="number"
                  @input="limitNumberObjectArray('transplant1', idx, 'transplantUsedSeedlingTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.usedTransplantTray}}</span> <!-- 사용 이식판 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="trans.usedTransplantTray"
                  type="number"
                  @input="limitNumberObjectArray('transplant1', idx, 'usedTransplantTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.transplantTotalCapa}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <input
                  v-model="trans.transplantTotalCapa"
                  type="number"
                  @input="limitNumberObjectArray('transplant1', idx, 'transplantTotalCapa', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.transplantRate}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <div class="farm-form-control form-control disabled-gray">{{ trans.transplantRate }}</div>
              </div> -->
            </div>
            <div class="text-center mt-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="addRow('transplant1',selectYieldManagement.cropNo)"
                class="mx-1"
              >+</b-button>
              <b-button
                v-if="transplant1.length > 1"
                variant="outline-danger"
                size="sm"
                @click="removeRow(transplant1.length - 1, 'transplant1')"
                class="mx-1"
              >-</b-button>
            </div>

            <div style="display: flex; justify-content: flex-end;">
              <b-button variant="primary" size="lg" @click="insertYieldManagement(3)"><span >{{ i18n.register }}</span></b-button>
              <b-button v-if="transplant1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement(3)">
                <span >{{ i18n.delete }}</span>
              </b-button>
            </div>


            <label class="col-form-label">
              <span class="h4">{{i18n.plant}}</span> 
            </label>
            <div
              class="form-group row mb-4"
              v-for="(plan, idx) in plant1"
              :key="`plant-${idx}`"
              style="padding-bottom: 15px; border-bottom: 1px solid #E4E6EF;"
            >
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.sowingDate}}</span> <!-- 파종일 -->
              </label>
              <div class="col-sm-4">
                <b-form-select
                  v-model="plan.plantSowingNo"
                  :options="sowingDateList"
                  class="disabled-white"
                ></b-form-select>
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.usedTransplantTray}}</span> <!-- 사용 이식판 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="plan.plantUsedTransplantTray"
                  type="number"
                  @input="limitNumberObjectArray('transplant1', idx, 'transplantUsedSeedlingTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.usedPlantingTray}}</span> <!-- 사용 정식판 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="plan.usedPlantingTray"
                  type="number"
                  @input="limitNumberObjectArray('transplant1', idx, 'usedTransplantTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.plantingArea}}</span> <!-- 정식구역 -->
              </label>
              <div class="col-sm-4">
                <div class="input-group" style="display: block;">
                  <div class="farm-form-control form-control scrollable-text" style="width: 100%;">{{ plan.farmRackNameList }}</div>
                  <div class="input-group-append">
                    <button class="btn btn-secondary" @click="showRackModal(idx)">{{i18n.sectionSelect}}</button>
                    <button class="btn btn-secondary" @click="showRackManagemnetModal()">{{i18n.sectionManagement}}</button>
                  </div>
                </div>
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.plantingTotalCapa}}</span> 
              </label>
              <div class="col-sm-4">
                <input
                  v-model="plan.plantingTotalCapa"
                  type="number"
                  @input="limitNumberObjectArray('transplant1', idx, 'usedTransplantTray', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.plantingRate}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <div class="farm-form-control form-control disabled-gray">{{ plan.plantingRate }}</div>
              </div> -->
            </div>
            <div class="text-center mt-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="addRow('plant1',selectYieldManagement.cropNo)"
                class="mx-1"
              >+</b-button>
              <b-button
                v-if="plant1.length > 1"
                variant="outline-danger"
                size="sm"
                @click="removeRow(plant1.length - 1, 'plant1')"
                class="mx-1"
              >-</b-button>
            </div>

            <div style="display: flex; justify-content: flex-end;">
              <b-button variant="primary" size="lg" @click="insertYieldManagement(4)"><span >{{ i18n.register }}</span></b-button>
              <b-button v-if="plant1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement(4)">
                <span >{{ i18n.delete }}</span>
              </b-button>
            </div>

            <label class="col-form-label">
              <span class="h4">{{i18n.harvest}}</span> 
            </label>
            <div
              class="form-group row mb-4"
              v-for="(harv, idx) in harvest1"
              :key="`harvest-${idx}`"
              style="padding-bottom: 15px; border-bottom: 1px solid #E4E6EF;"
            >
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.sowingDate}}</span> <!-- 파종일 -->
              </label>
              <div class="col-sm-4">
                <b-form-select
                  v-model="harv.harvestSowingNo"
                  :options="sowingDateList"
                  class="disabled-white"
                ></b-form-select>
                <!-- 수확완료여부 체크박스 -->
                <div class="mt-2">
                  <label class="d-flex align-items-center">
                    <input
                      type="checkbox"
                      v-model="harv.harvestCompletedYn"
                      class="mr-2"
                      true-value="Y"
                      false-value="N"
                    >
                    <span>{{ i18n.harvestCompleted }}</span>
                  </label>
                </div>
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.cultivationDays}}</span> 
              </label>
              <div class="col-sm-4 d-flex">
                <div class="farm-form-control form-control disabled-gray">{{ harv.cultivationDays }}</div>
              </div> -->
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.numberOfPlants}}</span> <!-- 포기수 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.numberOfPlants"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'numberOfPlants', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.rootMaterial}}</span> <!-- 뿌리원물 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.rootMaterial"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'rootMaterial', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.harvestYield}}</span> <!-- 수확량 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.harvestYield"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'harvestYield', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.targetHarvestYield}}</span> <!-- 목표수확량 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.targetHarvestYield"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'targetHarvestYield', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.excludingHarvestYield}}</span> <!-- 제외수확량 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.excludingHarvestYield"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'excludingHarvestYield', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.targetWeightPerPlant}}</span> <!-- 목표 포기당 중량 -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.targetWeightPerPlant"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'targetWeightPerPlant', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.weightPerPlant}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <div class="farm-form-control form-control disabled-gray">{{ harv.weightPerPlant }}</div>
              </div> -->
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.gradeARate}}</span> <!-- A급 비율  -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.gradeARate"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'gradeARate', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.numberOfDiscards}}</span> <!-- 폐기수  -->
              </label>
              <div class="col-sm-4">
                <input
                  v-model="harv.numberOfDiscards"
                  type="number"
                  @input="limitNumberObjectArray('harvest1', idx, 'numberOfDiscards', 6)"
                  class="farm-form-control form-control"
                >
              </div>
              <!-- <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.discardRate}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <div class="farm-form-control form-control disabled-gray">{{ harv.discardRate }}</div>
              </div>
              <label class="col-sm-2 col-form-label">
                <span class="h5">{{i18n.achievementRate}}</span> 
              </label>
              <div class="col-sm-4 d-flex align-items-center">
                <div class="farm-form-control form-control disabled-gray">{{ harv.achievementRate }}</div>
              </div> -->
              
            </div>
            <div class="text-center mt-2">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="addRow('harvest1', selectYieldManagement.cropNo)"
                class="mx-1"
              >+</b-button>
              <b-button
                v-if="harvest1.length > 1"
                variant="outline-danger"
                size="sm"
                @click="removeRow(harvest1.length - 1, 'harvest1')"
                class="mx-1"
              >-</b-button>
            </div>

            <div style="display: flex; justify-content: flex-end;">
              <b-button variant="primary" size="lg" @click="insertYieldManagement(5)"><span >{{ i18n.register }}</span></b-button>
              <b-button v-if="harvest1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement(5)">
                <span >{{ i18n.delete }}</span>
              </b-button>
            </div>



          </div>
        
        </div>
        <!--begin::Footer-->
          <!-- 등록 -->
          <div v-if="selectYieldManagement === null">
            <div class="card-footer" v-if="performanceTap.state === 0"> 
              <b-button variant="primary" size="lg" @click="insertYieldManagement(0)"><span >{{ i18n.register }}</span></b-button>
            </div>
          </div>
          <!-- <div v-else>
            <div class="card-footer">
              <b-button v-if="performanceTap.state !== 0" variant="primary" size="lg" @click="insertYieldManagement()"><span >{{ i18n.register }}</span></b-button>
              <b-button v-if="performanceTap.state === 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement()" >
                  <span >{{ i18n.delete }}</span>
              </b-button>
              <b-button v-if="performanceTap.state === 1 && sowing1.workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement()">
                <span >{{ i18n.delete }}</span>
              </b-button>
              <b-button v-if="performanceTap.state === 2 && seedling1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement()">
                <span >{{ i18n.delete }}</span>
              </b-button>
              <b-button v-if="performanceTap.state === 3 && transplant1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement()">
                <span >{{ i18n.delete }}</span>
              </b-button>
              <b-button v-if="performanceTap.state === 4 && plant1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement()">
                <span >{{ i18n.delete }}</span>
              </b-button>
              <b-button v-if="performanceTap.state === 5 && harvest1[0].workNo !== 0" variant="secondary" size="lg" class="ml-3" @click="deleteYieldManagement()">
                <span >{{ i18n.delete }}</span>
              </b-button>
              
            </div>
          </div> -->
        <!--end::Footer-->
        </div>
      </b-modal>

      <!-- 구역 선택 모달 -->
      <SectionSelectModal
        :sectionSelectModal = "sectionSelectModal"
        :farmInfo = "farmInfo"
        @sectionSelectModalUpdate = "sectionSelectModalUpdate"
        @farmRackNameList = "farmRackNameList"
      >
      </SectionSelectModal>

      <!-- 구역 관리 모달 -->
      <SectionManagementModal
        :rackManagementModal = "rackManagementModal"
        :farmInfo = "farmInfo"
        @rackManagementModalUpdate = "rackManagementModalUpdate"
      >  
      </SectionManagementModal>
    </div>
</template>

<script>
  import Vue from "vue";
  import {
    ACT_INSERT_YIELD_WORK,
    ACT_INSERT_YIELD_SOWING,
    ACT_INSERT_YIELD_SEEDLING,
    ACT_INSERT_YIELD_TRANSPLANT,
    ACT_INSERT_YIELD_PLANT,
    ACT_INSERT_YIELD_HARVEST,
    ACT_GET_YIELD_SOWING_DATE,
    ACT_UPDAETE_YIELD_SOWING,
    ACT_DELETE_YIELD_SOWING,


    ACT_GET_YIELD_SOWING_DATE_LIST
  } from '@/core/services/variable';
  import {ACT_ADD_ALERT, ACT_SHOW_CONFIRM_ALERT} from '@/core/services/store/alert.module';
  import {isSuccess, getResult, lan, utcToDate, timestampToDate, getTimeDifference, nullOrUndefinedCheck} from '@/core/services/funcs';
  import SectionSelectModal from '@/components/modal/SectionSelectModal';
  import SectionManagementModal from '@/components/modal/SectionManagementModal';
  import i18n from '@/core/plugins/vue-i18n.js';  
  export default {
    components: {
      SectionSelectModal,
      SectionManagementModal
    },
    props: {
      farmInfo: Object,
      registrationModal: Boolean,
      cropNmList: Array,
      selectYieldManagement: Object,
    },
    computed: {
      modalValue: {
        get() {
          return this.registrationModal;
        },
        set(value) {
          this.$emit("registrationModalUpdate", value);
        },
      },
    },
    data() {
      return {
        i18n: {
          sowing: i18n.t('farm.yield.sowing'),
          seedling: i18n.t('farm.yield.seedling'),
          transplant: i18n.t('farm.yield.transplant'),
          plant: i18n.t('farm.yield.plant'),
          harvest: i18n.t('farm.yield.harvest'),
          sowingDate: i18n.t('farm.yield.sowingDate'),
          seedlingDate: i18n.t('farm.yield.seedlingDate'),
          transplantDate: i18n.t('farm.yield.transplantDate'),
          plantDate: i18n.t('farm.yield.plantDate'),
          harvestDate: i18n.t('farm.yield.harvestDate'),
          crop: i18n.t('farm.yield.crop'),
          register: i18n.t('farm.cultivationCrop.register'),
          yearMonthDay: i18n.t('farm.yield.yearMonthDay'),
          edit: i18n.t('farm.yield.edit'), // 수정버튼
          delete: i18n.t('farm.yield.delete'), // 삭제버튼
          yieldRegistration: i18n.t('farm.yield.yieldRegistration'), // 실적 등록
          workRegistration : i18n.t('farm.yield.workRegistration'), // 작업 등록
          editYieldRegistration: i18n.t('farm.yield.editYieldRegistration'), // 수정정 등
          sowingRegistration: i18n.t('farm.yield.sowingRegistration'), // 파종 등록
          usedSowingTray: i18n.t('farm.yield.usedSowingTray'), // 사용파종판
          sowingTotalCapa: i18n.t('farm.yield.sowingTotalCapa'), // 파종 총 Capa
          sowingRate: i18n.t('farm.yield.sowingRate'), // 파종율
          usedSeedlingTray: i18n.t('farm.yield.usedSeedlingTray'), // 사용 모판
          seedlingTotalCapa: i18n.t('farm.yield.seedlingTotalCapa'), // 육묘 총 Capa
          germinationRate: i18n.t('farm.yield.germinationRate'), // 발아율
          usedTransplantTray: i18n.t('farm.yield.usedTransplantTray'), // 사용 이식판
          transplantTotalCapa: i18n.t('farm.yield.transplantTotalCapa'), // 이식 총 Capa
          transplantRate: i18n.t('farm.yield.transplantRate'), // 이식율 
          usedPlantingTray: i18n.t('farm.yield.usedPlantingTray'), // 사용 정식판 
          plantingTotalCapa: i18n.t('farm.yield.plantingTotalCapa'), // 사용 총 Capa 
          plantingArea: i18n.t('farm.yield.plantingArea'), // 정식구역 
          plantingRate: i18n.t('farm.yield.plantingRate'), // 정식률
          harvestYield: i18n.t('farm.yield.harvestYield'), // 수확량
          cultivationDays: i18n.t('farm.yield.cultivationDays'), // 재배일수
          
          targetHarvestYield: i18n.t('farm.yield.targetHarvestYield'), // 목표 수확량
          excludingHarvestYield: i18n.t('farm.yield.excludingHarvestYield'), // 제외수확량
          rootMaterial: i18n.t('farm.yield.rootMaterial'), // 뿌리원물
          numberOfPlants: i18n.t('farm.yield.numberOfPlants'), // 포기수
          numberOfDiscards: i18n.t('farm.yield.numberOfDiscards'), // 폐기수
          gradeARate: i18n.t('farm.yield.gradeARate'), // A급 비율
          discardRate: i18n.t('farm.yield.discardRate'), // 폐기율
          achievementRate: i18n.t('farm.yield.achievementRate'), // 달성율
          weightPerPlant: i18n.t('farm.yield.weightPerPlant'), // 포기당 중량
          targetWeightPerPlant: i18n.t('farm.yield.targetWeightPerPlant'), // 목표 포기당 중량
          selectSowingDateManagementNo : i18n.t('farm.yield.selectSowingDateManagementNo'), // 파종일 선택
          sectionSelect: i18n.t('farm.yield.sectionSelect'), // 구역 선택
          sectionManagement: i18n.t('farm.yield.sectionManagement'), // 구역 관리
          // 오류창
          rightValue: i18n.t('farm.yield.rightValue'),
          rightValueOrBaseValue: i18n.t('farm.yield.rightValueOrBaseValue'),
          confirm: i18n.t('farm.yield.confirm'),

          error: i18n.t('farm.yield.error'),
          deleteAlert: i18n.t('farm.yield.deleteAlert'),
          requiredInformation: i18n.t('farm.yield.requiredInformation'),

          workDate: i18n.t('farm.yield.workDate'), // 작업일
          harvestCompleted: i18n.t('farm.yield.harvestCompleted'), // 수확완료여부
        },
        workDate: null, // 작업일
        workNo: 0, // 작업 번호
        cropList: [{value:0, text:`${i18n.t('farm.yield.allCrops')}`, sowingTotalCapa : 0, seedlingTotalCapa : 0, transplantTotalCapa : 0, plantingTotalCapa : 0}], // 작물 리스트
        cropNo: 0, // 작물 번호
        cropNm: null, // 작물 이름
        cropNmEn: null, // 작물 이름 영문
        // 파종
        sowing1: {
          workNo: 0, // 작업 번호
          sowingNo: null, // 파종번호
          usedSowingTray : 0, // 사용 파종판
          sowingTotalCapa : 0, // 파종 총 Capa
          sowingRate: 0, // 파종율
        },
        // 육묘
        seedling1:[
          {
            workNo: 0, // 작업 번호
            seedlingSowingNo: 0, // 파종일 번호
            seedlingUsedSeedlingTray: 0, // 사용 모판
            seedlingTotalCapa: 0, // 육묘 총 Capa
            germinationRate: 0, // 발아율
          }
        ],

        // 이식
        transplant1:[
          {
            workNo: 0, // 작업 번호
            transplantSowingNo: 0, // 파종일 번호
            transplantUsedSeedlingTray: 0, // 사용 모판
            usedTransplantTray: 0, // 사용 이식판
            transplantTotalCapa: 0, // 이식 총 Capa
            transplantRate: 0, // 이식율
          }
        ],

        // 정식
        plant1:[
          {
            workNo: 0, // 작업번호
            plantSowingNo: 0, // 파종일 번호
            plantUsedTransplantTray: 0, // 사용 이식판
            usedPlantingTray: 0, // 사용 정식판
            farmRackNameList: null, // 정식구역
            plantingTotalCapa: 0, // 정식 총 케파
            plantingRate : 0, // 정식율
          }
        ],
        selectRackNo: 0, // 구역선택 배열 번호 

        // 수확
        harvest1:[
          {
            workNo : 0, // 작업번호
            harvestSowingNo : 0, // 파종일 번호
            numberOfPlants: 0, // 포기수 
            rootMaterial : 0, // 뿌리원물
            harvestYield : 0, // 수확량
            targetHarvestYield : 0, // 목표수확량
            excludingHarvestYield : 0, // 제외수확량 
            targetWeightPerPlant: 0, // 목표 포기당 중량
            weightPerPlant : 0, // 포기당 중량
            gradeARate : 0, // A급 비율 
            numberOfDiscards : 0, // 폐기수
            discardRate : 0, // 폐기율 
            achievementRate : 0, // 달성률
            harvestCompletedYn: "N", // 수확완료여부
            cultivationDays: 0, // 재배일수
          }
        ],
        sectionSelectModal: false, // 구역 선택 모달
        rackManagementModal: false, // 구역 관리 모달
        
        locale: lan(),
        performanceTap : { 
          content : [
            {text: i18n.t('farm.yield.work'), state: 0},
            {text: i18n.t('farm.yield.sowing'), state: 1},
            {text: i18n.t('farm.yield.seedling'), state: 2}, 
            {text: i18n.t('farm.yield.transplant'), state: 3}, 
            {text: i18n.t('farm.yield.plant'), state: 4}, 
            {text: i18n.t('farm.yield.harvest'), state: 5}
          ], 
          state : 0, // 0(작업), 1(파종), 2(육묘), 3(이식), 4(정식), 5(수확)
        },
        // 등록 가능 파종 일 리스트
        sowingDateList: [
          {value:0, text:i18n.t('farm.yield.selectSowingDate')},
        ],

        registrationSowing : { 
          selectSowingDateManagementNo : 0, // 파종일 선택
          sowingDate: null, // 등록 파종일
          cropNmList: [{value:0, text:`${i18n.t('farm.yield.allCrops')}`, sowingTotalCapa : 0, seedlingTotalCapa : 0, transplantTotalCapa : 0, plantingTotalCapa : 0}],
          cropNo: 0, // 등록 작물
          cropNm: null, // 작물이름
          cropNmEn: null, // 작물이름영문
          usedSowingTray: 0, // 등록 파종판
          sowingTotalCapa: 0, // 등록 파종 케파
          sowingRate: 0
        },
      }
    },
    watch: {
      /**
       * 모달 open일때
       */
      modalValue(value){
        if(value){
          this.performanceTap.state = 0;
          if(this.performanceTap.state === 0) {
            this.cropNo = 0
          }
          this.getSowingDateList()
          this.init()
        }
      },
      /**
       * 표 클릭 시
       */
      selectYieldManagement(value){
        if(value !== null) {
          this.selectYield(value)
          
        }
      },
    },
    created() {
      this.init()
    },
    methods: {
      /**
       * 초기화
       */
      init(){

        // 일자 셋팅
        let currentDate = new Date();
        currentDate.setDate(currentDate.getDate() - 1);
        this.workDate = utcToDate(currentDate, 'yyyy-MM-dd')

        this.cropList = [{value:0, text:`${i18n.t('farm.yield.allCrops')}`}], // 작물 리스트
        
        // 작물 드롭다운 리스트
        this.farmInfo.farmCultivateCrops.forEach( item => {
  
          this.cropList.push({value:item.cropNo ,text: lan() == 'ko' ? item.cropNm : item.cropNmEn})
        })

      },
  
      /**
       * 등록
       */
      insertYieldManagement(state) {
        this.performanceTap.state = state;

        // 작업 일자 등록 
        if(this.performanceTap.state === 0){

          const params = {
            workDate: this.workDate,
            fno: this.farmInfo.fno,
            cropNo: this.cropNo,
          }

          this.$store.dispatch(ACT_INSERT_YIELD_WORK, params).then((resp) =>{
            if(resp.status.code === 200){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 성공" : 'success', color: 'success'});

              this.$emit('regist',params)
              
              // 계산 데이터 재 등록
              this.calculateYeildManagement(this.performanceTap.state, resp.items[0])

            } else {
              if(resp.status.code === 412){
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
              }else{
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 실패" : 'fail'});
              }
            }

          })

        // 파종
        } else if(this.performanceTap.state === 1){
          //  유효성 검증

          if(this.selectYieldManagement.workNo === null || 
            Number(this.sowing1.usedSowingTray) < 0 || nullOrUndefinedCheck(this.sowing1.usedSowingTray) === null ||
            Number(this.sowing1.sowingTotalCapa) <= 0 || nullOrUndefinedCheck(this.sowing1.sowingTotalCapa) === null
          ) {
            this.errorMsg()
            return;            // 이걸 반드시 해줘야 루프 종료됨
          }
          const params = {
            sowingNo: this.sowing1.sowingNo,
            workNo : this.selectYieldManagement.workNo,
            usedSowingTray : this.sowing1.usedSowingTray,
            sowingTotalCapa : this.sowing1.sowingTotalCapa
          }
          // return;

          this.$store.dispatch(ACT_INSERT_YIELD_SOWING, params).then((resp) =>{
            if(resp.status.code === 200){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 성공" : 'success', color: 'success'});

              this.$emit('regist',params)
              
              // 계산 데이터 재 등록
              this.calculateYeildManagement(this.performanceTap.state, resp.items)
              this.getSowingDateList(); // 파종일 리스트 재조회

            } else {
              if(resp.status.code === 412){
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
              }else{
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 실패" : 'fail'});
              }
            }

          })

        // 육묘  
        } else if(this.performanceTap.state === 2){
          
          for (const item of this.seedling1) {
            if (
              item.seedlingSowingNo === 0 || 
              Number(item.seedlingUsedSeedlingTray) < 0 || nullOrUndefinedCheck(item.seedlingUsedSeedlingTray) === null ||
              Number(item.seedlingTotalCapa) < 0 || nullOrUndefinedCheck(item.seedlingTotalCapa) === null ||
              Number(item.germinationRate) < 0 || nullOrUndefinedCheck(item.germinationRate) === null
            ) {
              this.errorMsg();  // 에러 메시지 호출
              return;            // 이걸 반드시 해줘야 루프 종료됨
            }
          }


          this.seedling1.forEach(item => {
            item.workNo = this.selectYieldManagement.workNo
          })

          this.$store.dispatch(ACT_INSERT_YIELD_SEEDLING, this.seedling1).then((resp) =>{
            if(resp.status.code === 200){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 성공" : 'success', color: 'success'});

              this.$emit('regist',this.seedling1)
              
              // 계산 데이터 재 등록
              this.calculateYeildManagement(this.performanceTap.state, resp.items[0])

            } else {
              if(resp.status.code === 412){
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
              }else{
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 실패" : 'fail'});
              }
            }

          })

        // 이식  
        } else if(this.performanceTap.state === 3){

          // 유효성 검증
          for (const item of this.transplant1) {
            if (item.transplantSowingNo === 0 || 
                Number(item.transplantUsedSeedlingTray) < 0 || nullOrUndefinedCheck(item.transplantUsedSeedlingTray) === null || // 분모 0 안된다
                Number(item.transplantTotalCapa) < 0 || nullOrUndefinedCheck(item.transplantTotalCapa) === null ||
                Number(item.usedTransplantTray) < 0 || nullOrUndefinedCheck(item.usedTransplantTray) === null
            ) {
              this.errorMsg();  // 에러 메시지 호출
              return;            // 이걸 반드시 해줘야 루프 종료됨
            }
          }
        
          this.transplant1.forEach(item => {
            item.workNo = this.selectYieldManagement.workNo
          })
          this.$store.dispatch(ACT_INSERT_YIELD_TRANSPLANT, this.transplant1).then((resp) =>{
            if(resp.status.code === 200){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 성공" : 'success', color: 'success'});

              this.$emit('regist',this.transplant1)
              
              // 계산 데이터 재 등록
              this.calculateYeildManagement(this.performanceTap.state, resp.items)

            } else {
              if(resp.status.code === 412){
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
              }else{
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 실패" : 'fail'});
              }
            }

          })
        // 정식
        } else if(this.performanceTap.state === 4){

          // 유효성 검증
          for (const item of this.plant1) {
            if (item.plantSowingNo === 0 || 
              Number(item.plantUsedTransplantTray) < 0 || nullOrUndefinedCheck(item.plantUsedTransplantTray) === null ||
              Number(item.usedPlantingTray) < 0 || nullOrUndefinedCheck(item.usedPlantingTray) === null ||
              Number(item.plantingTotalCapa) < 0 || nullOrUndefinedCheck(item.plantingTotalCapa) === null
            ) {
              this.errorMsg();  // 에러 메시지 호출
              return;            // 이걸 반드시 해줘야 루프 종료됨
            }
          }
          this.plant1.forEach(item => {
            item.workNo = this.selectYieldManagement.workNo
          })

          this.$store.dispatch(ACT_INSERT_YIELD_PLANT, this.plant1).then((resp) =>{
            if(resp.status.code === 200){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 성공" : 'success', color: 'success'});

              this.$emit('regist',this.plant1)
              
              // 계산 데이터 재 등록
              this.calculateYeildManagement(this.performanceTap.state, resp.items)

            } else {
              if(resp.status.code === 412){
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
              }else{
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 실패" : 'fail'});
              }
            }

          })

        // 수확 
        } else if(this.performanceTap.state === 5) {

          // 유효성 검증
          for (const item of this.harvest1) {
            if (item.harvestSowingNo === 0 || 
              Number(item.harvestYield) < 0 || nullOrUndefinedCheck(item.harvestYield) === null ||
              Number(item.numberOfPlants) < 0 || nullOrUndefinedCheck(item.numberOfPlants) === null || 
              nullOrUndefinedCheck(item.excludingHarvestYield) === null || nullOrUndefinedCheck(item.targetWeightPerPlant)=== null || nullOrUndefinedCheck(item.rootMaterial) === null ||
              nullOrUndefinedCheck(item.gradeARate) === null || nullOrUndefinedCheck(item.numberOfDiscards) === null
            ) {
              this.errorMsg();  // 에러 메시지 호출
              return;            // 이걸 반드시 해줘야 루프 종료됨
            }
          }

          this.harvest1.forEach(item => {
            item.workNo = this.selectYieldManagement.workNo
            // item.harvestCompletedYn = item.harvestCompletedYn ; // 수확완료여부
          })
          // return

          this.$store.dispatch(ACT_INSERT_YIELD_HARVEST, this.harvest1).then((resp) =>{
            if(resp.status.code === 200){
              this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 성공" : 'success', color: 'success'});

              this.$emit('regist',this.harvest1)
              
              // 계산 데이터 재 등록
              this.calculateYeildManagement(this.performanceTap.state, resp.items)
              // this.getSowingDateList(); // 파종일 리스트 재조회

            } else {
              if(resp.status.code === 412){
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
              }else{
                this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? "등록 실패" : 'fail'});
              }
            }

          })
        }        
      },

      /**
       * 계산 데이터 재 등록
       */
      calculateYeildManagement(performanceState, item){
        // 파종 - 파종율
        if(performanceState === 1){
        
          this.sowing1.sowingNo = item[0].sowingNo
          this.sowing1.sowingRate = item[0].sowingRate
          this.sowing1.workNo = item[0].workNo
          
         // 육묘
        } else if(performanceState === 2){
        // 이식 - 이식율
        } else if(performanceState === 3){
          
          item.forEach((result, i) => {
            this.transplant1[i].transplantRate = result.transplantRate
          })
        
        // 정식 - 정식율
        } else if(performanceState === 4){

          item.forEach((result, i) => {
            this.plant1[i].plantingRate = result.plantingRate
          })
        
        // 수확
        } else if(performanceState === 5){
          item.forEach((result, i) => {
            this.harvest1[i].weightPerPlant = result.weightPerPlant // 포기당 중량
            this.harvest1[i].discardRate = result.discardRate // 폐기율
            this.harvest1[i].achievementRate = result.achievementRate // 달성율
            this.harvest1[i].cultivationDays = result.cultivationDays // 재배일수
          })

        }
      },

      /**
       * 실적 삭제
       */
      deleteYieldManagement(state) {
        this.performanceTap.state = state;

        let param = {
          state : null,
          workNo : null
        }
        if(this.performanceTap.state === 0){
          param.workNo = this.workNo;
        } else if(this.performanceTap.state === 1){
          param.workNo = this.sowing1.workNo;
        } else if(this.performanceTap.state === 2){
          param.workNo = this.seedling1[0].workNo;
        } else if(this.performanceTap.state === 3){
          param.workNo = this.transplant1[0].workNo;
        } else if(this.performanceTap.state === 4){
          param.workNo = this.plant1[0].workNo;
        } else if(this.performanceTap.state === 5){
          param.workNo = this.harvest1[0].workNo;
        }
        param.state = this.performanceTap.state;

        this.$store.dispatch(ACT_DELETE_YIELD_SOWING, param).then((resp) =>{
          if(isSuccess(resp)){
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage, color: 'success'});
            this.$emit('regist',null)
            // 모달 off
            this.modalValue = false

          }else{
            this.$store.dispatch(ACT_ADD_ALERT, {message: lan() == 'ko' ? getResult(resp).message : getResult(resp).enMessage });
          }
        })

      },

      /**
       * 클릭한 정보 모달에 넣기
       */
      selectYield(value){
       
        // 클릭한 정보
        if(value !== null) {
          if(this.registrationModal === true) {
            this.init()
            this.workDate = value.workDate; // 작업일
            this.cropNo = value.cropNo; // 작물 번호
            this.cropNm = value.cropNm // 작물 이름
            this.cropNmEn = value.cropNmEn // 작물 이름

            this.workNo = value.workNo;

            // 파종
            if(value.sowingNo === null) {
              
              this.sowing1.workNo = 0; // 작업번호
              this.sowing1.sowingNo = 0; // 파종번호
              this.sowing1.usedSowingTray = 0; // 사용 파종판
              
              this.farmInfo.farmCultivateCrops.forEach(item => {
              if(item.cropNo === value.cropNo) {
                  this.sowing1.sowingTotalCapa = nullOrUndefinedCheck(item.sowingTotalCapa) === null ? 0 : item.sowingTotalCapa; // 파종 총 Capa
                }
              })
              
              this.sowing1.sowingRate = 0; // 파종율
            } else {
              this.sowing1.workNo = value.workNo; // 작업번호
              this.sowing1.sowingNo = value.sowingNo; // 파종번호
              this.sowing1.usedSowingTray = value.usedSowingTray; // 사용 파종판
              this.sowing1.sowingTotalCapa = value.sowingTotalCapa; // 파종 총 Capa
              this.sowing1.sowingRate = value.sowingRate; // 파종율
            }
            

            // 육묘
            // 값이 없을 경우
            
            if(value.seedlingNo === null || value.seedlingNo.split('/').length === 0) {
              let seedlingTotalCapa = 0;
              this.farmInfo.farmCultivateCrops.forEach(item => {
              if(item.cropNo === value.cropNo) {
                  seedlingTotalCapa = nullOrUndefinedCheck(item.seedlingTotalCapa) === null ? 0 : item.seedlingTotalCapa; 
                }
              })
              this.seedling1 = [{
                workNo: 0, // 작업 번호
                seedlingSowingNo: 0, // 파종일 번호
                seedlingUsedSeedlingTray: 0, // 사용 모판
                seedlingTotalCapa: seedlingTotalCapa, // 육묘 총 Capa
                germinationRate: 0, // 발아율
              }]
            
            // 값이 있을 경우
            } else {
              this.seedling1 = [];

              const seedlingSowingNoList = value.seedlingSowingNo.split('/').map(s => Number(s.trim()));
              const usedTrayList = value.seedlingUsedSeedlingTray.split('/').map(s => Number(s.trim()));
              const totalCapaList = value.seedlingTotalCapa.split('/').map(s => Number(s.trim()));
              const germinationRateList = value.germinationRate.split('/').map(s => Number(s.trim())); // 예시 추가

              const length = Math.max(
                seedlingSowingNoList.length,
                usedTrayList.length,
                totalCapaList.length,
                germinationRateList.length
              );

              for (let i = 0; i < length; i++) {
                this.seedling1.push({
                  workNo: this.selectYieldManagement.workNo, // 작업 번호
                  seedlingSowingNo: seedlingSowingNoList[i],
                  seedlingUsedSeedlingTray: usedTrayList[i],
                  seedlingTotalCapa: totalCapaList[i],
                  germinationRate: germinationRateList[i]
                });
              }
            }
            
            // 이식
            if (value.transplantSowingNo === null || value.transplantSowingNo.split('/').length === 0) {
              let transplantTotalCapa = 0;
              this.farmInfo.farmCultivateCrops.forEach(item => {
              if(item.cropNo === value.cropNo) {
                  transplantTotalCapa = nullOrUndefinedCheck(item.transplantTotalCapa) === null ? 0 : item.transplantTotalCapa; 
                }
              })
              this.transplant1 = [{
                workNo: 0,
                transplantSowingNo: 0,
                transplantUsedSeedlingTray: 0,
                usedTransplantTray: 0,
                transplantTotalCapa: transplantTotalCapa,
                transplantRate: 0,
              }];
            } else {
              const transplantSowingNoList = value.transplantSowingNo.split('/').map(s => Number(s.trim()));
              const usedSeedlingTrayList = value.transplantUsedSeedlingTray.split('/').map(s => Number(s.trim()));
              const usedTransplantTrayList = value.usedTransplantTray.split('/').map(s => Number(s.trim()));
              const totalCapaList = value.transplantTotalCapa.split('/').map(s => Number(s.trim()));
              const transplantRateList = value.transplantRate.split('/').map(s => Number(s.trim()));

              const length = Math.max(
                transplantSowingNoList.length,
                usedSeedlingTrayList.length,
                usedTransplantTrayList.length,
                totalCapaList.length,
                transplantRateList.length
              );

              this.transplant1 = [];

              for (let i = 0; i < length; i++) {
                this.transplant1.push({
                  workNo: this.selectYieldManagement.workNo, // 작업 번호
                  transplantSowingNo: transplantSowingNoList[i] ?? 0,
                  transplantUsedSeedlingTray: usedSeedlingTrayList[i] ?? 0,
                  usedTransplantTray: usedTransplantTrayList[i] ?? 0,
                  transplantTotalCapa: totalCapaList[i] ?? 0,
                  transplantRate: transplantRateList[i] ?? 0,
                });
              }
            }

            // 정식
            if (value.plantSowingNo === null || value.plantSowingNo.split('/').length === 0) {
              let plantingTotalCapa = 0;
              this.farmInfo.farmCultivateCrops.forEach(item => {
              if(item.cropNo === value.cropNo) {
                  plantingTotalCapa = nullOrUndefinedCheck(item.plantingTotalCapa) === null ? 0 : item.plantingTotalCapa; 
                }
              })
              
              this.plant1 = [{
                workNo: 0,
                plantSowingNo: 0,
                plantUsedTransplantTray: 0,
                usedPlantingTray: 0,
                farmRackNameList: null,
                plantingTotalCapa: plantingTotalCapa,
                plantingRate: 0
              }];
            } else {
              const plantSowingNoList = value.plantSowingNo.split('/').map(s => Number(s.trim()));
              const plantUsedTransplantTrayList = value.plantUsedTransplantTray.split('/').map(s => Number(s.trim()));
              const usedPlantingTrayList = value.usedPlantingTray.split('/').map(s => Number(s.trim()));
              const farmRackNameList = value.farmRackNameList === null ? [] : value.farmRackNameList.split('/').map(s => s.trim());
              const plantingTotalCapaList = value.plantingTotalCapa.split('/').map(s => Number(s.trim()));
              const plantingRateList = value.plantingRate.split('/').map(s => Number(s.trim()));

              const length = Math.max(
                plantSowingNoList.length,
                plantUsedTransplantTrayList.length,
                usedPlantingTrayList.length,
                farmRackNameList.length,
                plantingTotalCapaList.length,
                plantingRateList.length
              );

              this.plant1 = [];

              for (let i = 0; i < length; i++) {
                this.plant1.push({
                  workNo: this.selectYieldManagement.workNo, // 작업 번호
                  plantSowingNo: plantSowingNoList[i] ?? 0,
                  plantUsedTransplantTray: plantUsedTransplantTrayList[i] ?? 0,
                  usedPlantingTray: usedPlantingTrayList[i] ?? 0,
                  farmRackNameList: farmRackNameList[i] ?? '',
                  plantingTotalCapa: plantingTotalCapaList[i] ?? 0,
                  plantingRate: plantingRateList[i] ?? 0
                });
              }
            }

            // 수확
            if (value.harvestSowingNo === null || value.harvestSowingNo.split('/').length === 0) {
              let targetHarvestYield = 0;
              let targetWeightPerPlant = 0;
              this.farmInfo.farmCultivateCrops.forEach(item => {
              if(item.cropNo === value.cropNo) {
                  targetHarvestYield = nullOrUndefinedCheck(item.targetHarvestYield) === null ? 0 : item.targetHarvestYield; // 목표수확량
                  targetWeightPerPlant =  nullOrUndefinedCheck(JSON.parse(item.cropEnvJson).standardWeight) === null ? 0 : JSON.parse(item.cropEnvJson).standardWeight
                }
              })

              this.harvest1 = [{
                workNo : 0, // 작업번호
                harvestSowingNo : 0, // 파종일 번호
                numberOfPlants: 0, // 포기수 
                rootMaterial : 0, // 뿌리원물
                harvestYield : 0, // 수확량
                targetHarvestYield : targetHarvestYield, // 목표수확량
                excludingHarvestYield : 0, // 제외수확량 
                targetWeightPerPlant: targetWeightPerPlant, // 목표 포기당 중량
                weightPerPlant : 0, // 포기당 중량
                gradeARate : 0, // A급 비율 
                numberOfDiscards : 0, // 폐기수
                discardRate : 0, // 폐기율 
                achievementRate : 0, // 달성률
                harvestCompletedYn: 'N', // 수확완료여부
                cultivationDays: 0 // 재배일수
              }];
            } else {

              const harvestSowingNoList = value.harvestSowingNo.split('/').map(s => Number(s.trim()));
              const numberOfPlantsList = value.numberOfPlants.split('/').map(s => Number(s.trim()));
              const rootMaterialList = value.rootMaterial.split('/').map(s => Number(s.trim()));
              const harvestYieldList = value.harvestYield.split('/').map(s => Number(s.trim()));
              const targetHarvestYieldList = value.targetHarvestYield.split('/').map(s => Number(s.trim()));
              const excludingHarvestYieldList = value.excludingHarvestYield.split('/').map(s => Number(s.trim()));
              const targetWeightPerPlantList = value.targetWeightPerPlant.split('/').map(s => Number(s.trim()));
              const weightPerPlantList = value.weightPerPlant.split('/').map(s => Number(s.trim()));
              const gradeARateList = value.gradeARate.split('/').map(s => Number(s.trim()));
              const numberOfDiscardsList = value.numberOfDiscards.split('/').map(s => Number(s.trim()));
              const discardRateList = value.discardRate.split('/').map(s => Number(s.trim()));
              const achievementRateList = value.achievementRate.split('/').map(s => Number(s.trim()));
              const harvestCompletedYnList = value.harvestCompleteYn.split('/').map(s => s.trim());
              const cultivationDaysList = value.cultivationDays.split('/').map(s => Number(s.trim()));

              const length = Math.max(
                harvestSowingNoList.length,
                numberOfPlantsList.length,
                rootMaterialList.length,
                harvestYieldList.length,
                targetHarvestYieldList.length,
                excludingHarvestYieldList.length,
                targetWeightPerPlantList.length,
                weightPerPlantList.length,
                gradeARateList.length,
                numberOfDiscardsList.length,
                discardRateList.length,
                achievementRateList.length,
                cultivationDaysList.length,
              );

              this.harvest1 = [];

              for (let i = 0; i < length; i++) {
                this.harvest1.push({
                  workNo: this.selectYieldManagement.workNo, // 작업 번호
                  harvestSowingNo: harvestSowingNoList[i] ?? 0,
                  numberOfPlants: numberOfPlantsList[i] ?? 0,
                  rootMaterial: rootMaterialList[i] ?? 0,
                  harvestYield: harvestYieldList[i] ?? 0,
                  targetHarvestYield: targetHarvestYieldList[i] ?? 0,
                  excludingHarvestYield: excludingHarvestYieldList[i] ?? 0,
                  targetWeightPerPlant: targetWeightPerPlantList[i] ?? 0,
                  weightPerPlant: weightPerPlantList[i] ?? 0,
                  gradeARate: gradeARateList[i] ?? 0,
                  numberOfDiscards: numberOfDiscardsList[i] ?? 0,
                  discardRate: discardRateList[i] ?? 0,
                  achievementRate: achievementRateList[i] ?? 0,
                  harvestCompletedYn: harvestCompletedYnList[i],  // 수확완료 여부
                  cultivationDays: cultivationDaysList[i] ?? 0 // 재배일수
                });
              }
            }
          }
        }
        
      },

      /**
       * 구역 선택으로 넘어온 데이터
       */
      farmRackNameList(value){
        this.plant1[this.selectRackNo].farmRackNameList = value.rackLocation
        this.plant1[this.selectRackNo].plantingTotalCapa = value.plantingTotalCapa
      },

      /**
       * 구역선택 모달 닫기
       */
      sectionSelectModalUpdate(vlaue){
        this.sectionSelectModal = vlaue
      },

      /**
       * 구역 선택 모달 오픈
       */
      showRackModal(idx){
        this.selectRackNo = idx // 몇번째 구역선택을 열었는지 
        this.sectionSelectModal = true
      },

      /**
       * 구역 선택 모달 닫기
       */
      rackManagementModalUpdate(){
        this.rackManagementModal = false
      },

      /**
       * 구역 관리 모달 클릭 오픈
       */
      showRackManagemnetModal(){
        this.rackManagementModal = true
      },

      /**
       * 실적 등록 탭 클릭
       */
      changeRegistrationConnect(i){
        this.performanceTap.state = i
        this.getSowingDateList()
      },

      /**
       * 등록가능한 파종일 조회
       */
      getSowingDateList(){
        if(this.selectYieldManagement === null) {
          return false
        }
        this.sowingDateList = []
        this.sowingDateList.push({value:0, text:i18n.t('farm.yield.selectSowingDate')},)
        const parms = {
          workNo : this.selectYieldManagement.workNo,
          completeYn : 'N',
        }

        this.$store.dispatch(ACT_GET_YIELD_SOWING_DATE_LIST, parms).then((resp) =>{

          resp.items.forEach(item => {
            const sowingDateValue = {
              value : item.sowingNo,
              text : item.sowingDate
            }
            this.sowingDateList.push(sowingDateValue)
          })

          // 파종일은 완료시키면 없어지므로 없는 파종일이 있는경우 다시 일시적으로 넣고 재정렬
          // 육묘탭 && 파종일이 있는 경우
          if(this.selectYieldManagement.seedlingSowingNo !== null ) {
            const seedlingSowingNoList = this.selectYieldManagement.seedlingSowingNo.split('/').map(s => Number(s.trim()));
            const seedlingWorkDateList = this.selectYieldManagement.seedlingWorkDate.split('/').map(s => s.trim());
            const combinedList = seedlingSowingNoList.map((sowingNo, index) => ({
              text: seedlingWorkDateList[index],
              value: sowingNo,
            }));

            // sowingDateList에 없는 value만 추가(중복 방지, 파종일 완료되서 없을 수 있다)
            combinedList.forEach(newItem => {
              const exists = this.sowingDateList.some(existing => existing.value === newItem.value);
              if (!exists) {
                this.sowingDateList.push(newItem);
              }
            });

          // 이식탭 && 파종일이 있는 경우  
          }
          if(this.selectYieldManagement.transplantSowingNo !== null) {
            const transplantSowingNoList = this.selectYieldManagement.transplantSowingNo.split('/').map(s => Number(s.trim()));
            const transplantWorkDateList = this.selectYieldManagement.transplantWorkDate.split('/').map(s => s.trim()); 
            const combinedList = transplantSowingNoList.map((sowingNo, index) => ({
              text: transplantWorkDateList[index],
              value: sowingNo,
            }));

            // sowingDateList에 없는 value만 추가(중복 방지, 파종일 완료되서 없을 수 있다)
            combinedList.forEach(newItem => {
              const exists = this.sowingDateList.some(existing => existing.value === newItem.value);
              if (!exists) {
                this.sowingDateList.push(newItem);
              }
            });
          
          // 정식탭 && 파종일이 있는 경우
          } 
          if(this.selectYieldManagement.plantSowingNo !== null) {
            const plantSowingNoList = this.selectYieldManagement.plantSowingNo.split('/').map(s => Number(s.trim()));
            const plantWorkDateList = this.selectYieldManagement.plantWorkDate.split('/').map(s => s.trim());
            const combinedList = plantSowingNoList.map((sowingNo, index) => ({
              text: plantWorkDateList[index],
              value: sowingNo,
            }));

            // sowingDateList에 없는 value만 추가(중복 방지, 파종일 완료되서 없을 수 있다)
            combinedList.forEach(newItem => {
              const exists = this.sowingDateList.some(existing => existing.value === newItem.value);
              if (!exists) {
                this.sowingDateList.push(newItem);
              }
            });

          // 수확탭 && 파종일이 있는 경우
          } 
          if(this.selectYieldManagement.harvestSowingNo !== null) {
            const harvestSowingNoList = this.selectYieldManagement.harvestSowingNo.split('/').map(s => Number(s.trim()));
            const harvestWorkDateList = this.selectYieldManagement.harvestWorkDate.split('/').map(s => s.trim());
            const combinedList = harvestSowingNoList.map((sowingNo, index) => ({
              text: harvestWorkDateList[index],
              value: sowingNo,
            }));

            // sowingDateList에 없는 value만 추가(중복 방지, 파종일 완료되서 없을 수 있다)
            combinedList.forEach(newItem => {
              const exists = this.sowingDateList.some(existing => existing.value === newItem.value);
              if (!exists) {
                this.sowingDateList.push(newItem);
              }
            });
          }

          const [first, ...rest] = this.sowingDateList;

          // 날짜 순으로 내림차순 정렬 (최신일자 먼저)
          rest.sort((a, b) => b.text.localeCompare(a.text));

          // 다시 배열을 합침
          this.sowingDateList = [first, ...rest];
        })
      },

      /**
       * 숫자수 제한 (단일 값용)
       */
      limitNumberObject(obj,key, limitValue) {
        if(this[obj][key].length >= limitValue) {
          this[obj][key] = this[obj][key].slice(0,limitValue)
        }
      },

      /**
       * 배열용 숫자수 제한 (육묘 v-for 등)
       */
      limitNumberObjectArray(arrName, idx, key, limitValue) {
        if (
          this[arrName] &&
          this[arrName][idx] &&
          String(this[arrName][idx][key]).length > limitValue
        ) {
          this[arrName][idx][key] = String(this[arrName][idx][key]).slice(0, limitValue);
        }
      },

      /**
       * 오류창
       */
      errorMsg(){
        let info = {}
        info.title = this.i18n.rightValueOrBaseValue
        info.icon = 'error'
        info.focusConfirm = true
        info.confirmButtonColor = '#131628'
        info.confirmButtonText = this.i18n.confirm
        Vue.swal.fire(info)
      },

      /**
       * 실적 더하기
       */
      addRow(value, cropNo) {
        // 육묘
        if(value === 'seedling1') { 
          let seedlingTotalCapa = 0;
          this.farmInfo.farmCultivateCrops.forEach(item => {
          if(item.cropNo === cropNo) {
              seedlingTotalCapa = nullOrUndefinedCheck(item.seedlingTotalCapa) === null ? 0 : item.seedlingTotalCapa; 
            }
          })
          this.seedling1.push({
            seedlingSowingNo: 0,
            seedlingUsedSeedlingTray: 0,
            seedlingTotalCapa: seedlingTotalCapa,
            germinationRate: 0,
          });

        // 이식
        } else if(value === 'transplant1') {

          let transplantTotalCapa = 0;
          this.farmInfo.farmCultivateCrops.forEach(item => {
          if(item.cropNo === cropNo) {
              transplantTotalCapa = nullOrUndefinedCheck(item.transplantTotalCapa) === null ? 0 : item.transplantTotalCapa; 
            }
          })

          this.transplant1.push({
            workNo: 0, // 작업 번호
            transplantSowingNo: 0, // 파종일 번호
            transplantUsedSeedlingTray: 0, // 사용 모판
            usedTransplantTray: 0, // 사용 이식판
            transplantTotalCapa: transplantTotalCapa, // 이식 총 Capa
            transplantRate: 0, // 이식율
          });

        // 정식
        } else if(value === 'plant1') {
          let plantingTotalCapa = 0;
          this.farmInfo.farmCultivateCrops.forEach(item => {
          if(item.cropNo === cropNo) {
              plantingTotalCapa = nullOrUndefinedCheck(item.plantingTotalCapa) === null ? 0 : item.plantingTotalCapa; 
            }
          })

          this.plant1.push({
            workNo: 0, // 작업번호
            plantSowingNo: 0, // 파종일 번호
            plantUsedTransplantTray: 0, // 사용 이식판
            usedPlantingTray: 0, // 사용 정식판
            farmRackNameList: null, // 정식구역
            plantingTotalCapa: plantingTotalCapa, // 정식 총 케파
            plantingRate : 0, // 정식율
          });

        // 수확
        } else if(value === 'harvest1') {
          let targetHarvestYield = 0;
          let targetWeightPerPlant = 0;
          this.farmInfo.farmCultivateCrops.forEach(item => {
          if(item.cropNo === cropNo) {
              targetHarvestYield = nullOrUndefinedCheck(item.targetHarvestYield) === null ? 0 : item.targetHarvestYield; // 목표수확량
              targetWeightPerPlant =  nullOrUndefinedCheck(JSON.parse(item.cropEnvJson).standardWeight) === null ? 0 : JSON.parse(item.cropEnvJson).standardWeight
            }
          })

          this.harvest1.push({
            workNo : 0, // 작업번호
              harvestSowingNo : 0, // 파종일 번호
              numberOfPlants: 0, // 포기수 
              rootMaterial : 0, // 뿌리원물
              harvestYield : 0, // 수확량
              targetHarvestYield :targetHarvestYield, // 목표수확량
              excludingHarvestYield : 0, // 제외수확량 
              targetWeightPerPlant: targetWeightPerPlant, // 목표 포기당 중량
              weightPerPlant : 0, // 포기당 중량
              gradeARate : 0, // A급 비율 
              numberOfDiscards : 0, // 폐기수
              discardRate : 0, // 폐기율 
              achievementRate : 0, // 달성률
              harvestCompletedYn: 'N' // 수확완료여부
          });
        }

      },

      /**
       * 실적 빼기
       */
      removeRow(idx, value) {
        if(value === 'seedling1') {
          this.seedling1.splice(idx, 1);
        } else if(value === 'transplant1') {
          this.transplant1.splice(idx, 1);
        } else if(value === 'plant1') {
          this.plant1.splice(idx, 1);
        } else if(value === 'harvest1') {
          this.harvest1.splice(idx, 1);
        }
      },
    },
  }

</script>
<style scoped lang="scss">
  // 비활성화 색
  .disabled-gray {
    background-color : #e9ecef !important;
  }
  // 활성화 색
  .disabled-white {
    background-color : white !important;
  }

  // 정식구역 스크롤바
  .scrollable-text {
    white-space: nowrap;        /* 텍스트 줄바꿈 방지 */
    overflow-x: auto;          /* X축 스크롤 활성화 */
    overflow-y: hidden;        /* Y축 스크롤 비활성화 */
    max-width: 100%;           /* 부모 요소의 너비 제한 */
    display: flex;             /* Flexbox 사용 */
    align-items: center;       /* 세로 가운데 정렬 */
    padding: 5px;              /* 내부 여백 추가 */
    box-sizing: border-box;    /* 여백과 테두리 포함 */
  }
  /* 스크롤바 스타일 */
  .scrollable-text::-webkit-scrollbar {
    height: 6px;               /* 스크롤바 높이 */
  }
  .scrollable-text::-webkit-scrollbar-thumb {
    background: #888;          /* 스크롤바 색상 */
    border-radius: 3px;        /* 스크롤바 모서리 둥글게 */
  }
  .scrollable-text::-webkit-scrollbar-thumb:hover {
    background: #555;          /* 마우스 오버 시 색상 변경 */
  }
  .scrollable-text::-webkit-scrollbar-track {
    background: #f1f1f1;       /* 스크롤바 트랙 색상 */
  }
  .scrollable-sticky {
    position: sticky;          /* 스크롤 시 고정 */
    top: 0;                    /* 화면 상단에 고정 */
    z-index: 10;               /* 다른 요소보다 위에 표시되도록 설정 */
  }
  // 텍스트 넘침 줄바꿈
  span.h5 {
    white-space: normal;
  }
  // 위험표시
  .text-danger {
    position: relative;
    top: -15px;
  }
</style>